import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isEnabledForFrontierCopilotAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';
import { isCopilotLicensedAndEnabledUser } from './isCopilotLicensedAndEnabledUser';

const navigationFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'cal-ai-event-highlighting-frontier-public',
    privateTapFlight: 'cal-ai-event-highlighting-frontier-private-tap',
    privateStagingFlight: 'cal-ai-event-highlighting-frontier-private-staging',
    privateInfluencerFlight: 'cal-ai-event-highlighting-frontier-private-influencer',
};

/**
 * Single check for whether Copilot navigation/highlighting is enabled in Calendar.
 * Requires a copilot license, then returns true if EITHER:
 * - The global `cal-ai-event-highlighting` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isCopilotNavigationInCalendarEnabled(
    mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
): boolean {
    if (!isCopilotLicensedAndEnabledUser(mailboxInfo)) {
        return false;
    }
    return (
        isGlobalFeatureEnabled('cal-ai-event-highlighting') ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, navigationFrontierFlights)
    );
}
